import { green, orange, red } from "@material-ui/core/colors";
import { StatusIncident } from "api";

export enum StatusIncidentReviewRequest {
    OPEN = "OPEN",
    ACCEPT = "ACCEPT",
    UNACCEPT = "UNACCEPT",
}

export const StatusIncidentReviewRequestDescription = {
    OPEN: "Aberto",
    ACCEPT: "Aceito",
    UNACCEPT: "Não aceito",
};

export const StatusIncidentReviewRequestColor = {
    OPEN: orange["500"],
    ACCEPT: green["500"],
    UNACCEPT: red["500"],
};

export interface IncidentReviewRequest {
    id: string;
    requestUserId: string;
    requestDriverNumber: string;
    description: string;
    status: StatusIncidentReviewRequest;
    championshipId: string;
    roundId: string;
    raceControlId: string;
    initialInfractionId: string;
    incidentId: string;
    initialStatusIncident: StatusIncident;
    answerDescription?: string;
}

export const IncidentReviewRequestDefault = {
    id: "",
    requestUserId: "",
    requestDriverNumber: "",
    description: "",
    status: "",
    championshipId: "",
    roundId: "",
    raceControlId: "",
    initialInfractionId: "",
    incidentId: "",
    initialStatusIncident: "",
    answerDescription: "",
};
